import { useMemo } from 'react';
import { MdOutlineVisibility } from 'react-icons/md';
import { StoreDetailsStore } from 'zustand-store';
import { HistoryContent } from 'types';
import { Heading, History, Modal, Text } from 'components';
import { addToHistoryList } from 'helpers';
import { FontSize, FontWeight, TEST_IDS } from 'commons';
import { OpeningHistoryContent } from './components';
import * as S from './styles';

export function OpeningDayHistory() {
  const { storeDetails } = StoreDetailsStore.useStore();

  const openingDaysHistory = useMemo(
    () => storeDetails.openingDaysHistory,
    [storeDetails]
  );

  const formattedHistory = useMemo(() => {
    if (openingDaysHistory) {
      return openingDaysHistory.reduce<HistoryContent[]>((acc, openingDay) => {
        const content = <OpeningHistoryContent historyEntry={openingDay} />;

        return addToHistoryList({
          list: acc,
          content,
          date: openingDay.date,
        });
      }, []);
    }

    return [];
  }, [openingDaysHistory]);

  const renderContent = (
    <S.Main data-testid={TEST_IDS.OPENING_DAYS_HISTORY_CONTENT}>
      <S.TitleWrapper>
        <Heading size={FontSize.font16} weight={FontWeight.bold}>
          Histórico de horários
        </Heading>
      </S.TitleWrapper>

      <S.HistoryWrapper>
        {formattedHistory.length ? (
          <History content={formattedHistory} />
        ) : (
          <Text size={FontSize.font12}>Não existem alterações</Text>
        )}
      </S.HistoryWrapper>
    </S.Main>
  );

  return (
    <Modal
      data-testid={TEST_IDS.OPENING_DAYS_HISTORY_BUTTON}
      modalContent={renderContent}
    >
      <S.ButtonTextWrapper>
        <MdOutlineVisibility size={16} />

        <Text size={FontSize.font12} weight={FontWeight.bold}>
          Histórico de alterações
        </Text>
      </S.ButtonTextWrapper>
    </Modal>
  );
}
